import React from 'react';

import * as S from './RadioButton.styles';

const RadioButton = ({id, onChange, children, name, classes, defaultChecked}) => {
  return (
    <S.RadioBtn className={classes}>
        <input type="radio" id={id} defaultChecked={defaultChecked} onChange={onChange} name={name} />
        <label htmlFor={id}>{children}</label>
    </S.RadioBtn>
  )
}

export default RadioButton;